export type { TableColumn, TableProps } from "./Table";
export { Table } from "./Table";
